// extracted by mini-css-extract-plugin
export default {"tabButtonGroup":"app-tabs_tabButtonGroup__wfcbC","tabButton":"app-tabs_tabButton__6JK98","selected":"app-tabs_selected__AeBcM"};